// extracted by mini-css-extract-plugin
export default {"container":"create-geofence_container__d-uaN","headline-section":"create-geofence_headline-section__mWagu","content":"create-geofence_content__xs9Kq"};